package one.healthium.domain.user.models

import kotlinx.serialization.Serializable

@Serializable
data class SymptomModel(
    val kind: SymptomKind,
    val severity: SymptomSeverity,
)

@Serializable
enum class SymptomKind {
    Bloating,
    ExcessGas,
    Constipation,
    Unknown,
}

@Serializable
enum class SymptomSeverity {
    Good,
    Neutral,
    Bad
}